import api from "./api";

export const getsPais = async () => {
    const response = await api.get(
        "/UbigeoView/GetPaises"
    );

    return response.data.data;
}

export const getsDepartamentosByIdPais = async (idPais) => {
    const response = await api.get(
        "/UbigeoView/GetDepartamentosByIdPais",{params: {idPais}}
    );

    return response.data.data;
}

export const getsProvinciasByIdDepartamento = async (idDepartamento) => {
    const response = await api.get(
        "/UbigeoView/GetProvinciasByIdDepartamento",{params: {idDepartamento}}
    );

    return response.data.data;
}

export const getsUbigeosByIdProvincia = async (idProvincia) => {
    const response = await api.get(
        "/UbigeoView/GetUbigeosByIdProvincia",{params: {idProvincia}}
    );

    return response.data.data;
}
